import React from 'react';
import { PieChart, Pie, Cell, Legend, Tooltip } from 'recharts';
import Card from 'components/Card';
import { DocumentTextIcon } from '@heroicons/react/outline';

const generateDistinctColors = (count, hue) => {
  const colors = [];
  const goldenRatio = 0.618033988749895;
  for (let i = 0; i < count; i++) {
    hue += goldenRatio;
    hue %= 1;
    const color = `hsl(${Math.floor(hue * 360)}, 70%, 50%)`;
    colors.push(color);
  }
  return colors;
};

const LeadQualityChart = ({
  title,
  lqResponseData,
  lqBookedData,
  lqPitchedData,
}) => {
  // Convert object to array
  const chartBookedData = Object.values(lqBookedData);
  const chartResponseData = Object.values(lqResponseData);
  const chartPitcheData = Object.values(lqPitchedData);

  const distinctColorsBooked = generateDistinctColors(
    chartBookedData.length,
    Math.random()
  );

  const distinctColorsResponse = generateDistinctColors(
    chartResponseData.length,
    Math.random()
  );

  const distinctColorsPitch = generateDistinctColors(
    chartPitcheData.length,
    Math.random()
  );

  //   const total = chartSourceData.reduce((acc, entry) => acc + entry.value, 0);

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const dataItem = payload[0].payload;
      return (
        <div className="bg-white shadow-md p-2 border border-gray-300 rounded">
          <p>{dataItem.label}</p>
          <p>{`${dataItem.name} : ${dataItem.value}`}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <Card>
      <div className="flex justify-center">
        <div className="w-1/2 flex justify-center">
          <div>
            <h2 className="text-center text-xl font-bold">
              <DocumentTextIcon className="inline w-5 h-5 mb-1" /> {title}
            </h2>
            <div className="pt-4 text-center">
              <span className="text-red-600 px-1">Outer: Pitches</span>
              <span className="text-purple-600 px-1">Mid: Responses</span>
              <span className="text-blue-600 px-1">Inner: Bookings</span>
            </div>

            <PieChart width={300} height={300}>
              <Pie
                data={chartBookedData}
                cx={150}
                cy={150}
                innerRadius={20}
                outerRadius={80}
                fill="#8884d8"
                paddingAngle={3}
                dataKey="value"
                label
              >
                {chartBookedData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={distinctColorsBooked[index]}
                  />
                ))}
              </Pie>

              <Pie
                data={chartResponseData}
                cx={150}
                cy={150}
                innerRadius={80}
                outerRadius={90}
                fill="#8884d8"
                paddingAngle={3}
                dataKey="value"
                label
              >
                {chartResponseData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={distinctColorsResponse[index]}
                  />
                ))}
              </Pie>

              <Pie
                data={chartPitcheData}
                cx={150}
                cy={150}
                innerRadius={90}
                outerRadius={100}
                fill="#8884d8"
                paddingAngle={3}
                dataKey="value"
                label
              >
                {chartResponseData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={distinctColorsPitch[index]}
                  />
                ))}
              </Pie>

              <Tooltip content={<CustomTooltip />} />
            </PieChart>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default LeadQualityChart;
